import { connect } from 'react-redux';
import { updateFilter, getUsers, getProfilePhoto } from '../../actions';
import './style.scss';
import Filter from './component';

const getFilters = answers => (
  Object.keys(answers)
    .reduce((filters, name) => {
      const { options, required, type } = answers[name];
      const formattedName = name.replace(/_/g, ' ');
      if (name.startsWith('question_importance')) {
        return filters;
      }
      if (required && (type === 'multiple' || type === 'checkbox')) {
        return {
          ...filters,
          [formattedName]: options,
        };
      }
      return filters;
    }, {})
);

const mapStateToProps = state => (
  {
    filter: state.feed.filter,
    masterFilterKeys: getFilters(state.user.answers),
    users: state.feed.users,
  }
);

export default connect(mapStateToProps, { updateFilter, getUsers, getProfilePhoto })(Filter);
